<template>
  <MazPhoneNumberInput
    :class="[
      hasError || hasVendorError ? 'border-error' : 'border-neutral-20',
      isRequired ? 'required-asterisk' : ''
    ]"
    show-code-on-list
    :preferred-countries="['PL', 'UA', 'GB']"
    no-example
    :default-phone-number="phoneNumber"
    :model-value="phoneNumber"
    :default-country-code="country"
    :label="$t('auth.phone')"
    :required="isRequired"
    :translations="{
      countrySelector: {
        placeholder: '',
        searchPlaceholder: $t('action.search'),
      },
      phoneInput: {
        placeholder: '',
      },
    }"
    @update="onUpdate"
    @update:model-value="onUpdateValue"
  />

  <BaseErrorMessage v-if="hasError">
    {{ $t(errorMsg) }}
  </BaseErrorMessage>

  <slot name="errors"></slot>
</template>

<script setup>
import { prop } from 'dom7'
import MazPhoneNumberInput from 'maz-ui/components/MazPhoneNumberInput'

const emit = defineEmits(['update'])

const props = defineProps({
  name: {
    type: [String],
    default: '',
  },
  phoneNumber: {
    type: [String],
    default: '',
  },
  country: {
    type: [String],
    default: 'PL',
  },
  hasVendorError: {
    type: [Boolean],
    default: false,
  },
  isRequired: {
    type: [Boolean],
    default: false,
  },
  errors: {
    type: [Object],
    default: null,
  },
  anyDirty: {
    type: [Boolean],
    default: true,
  },
})

const result = ref(null)

const hasError = computed(() => {
  return props.anyDirty && props.errors && props.errors?.[props.name]
})

const errorMsg = computed(() => {
  return props.errors[props.name] instanceof Array
    ? props.errors[props.name][0]
    : props.errors[props.name]
})

const onUpdateValue = ($event) => {
  if (
    $event?.nationalNumber != undefined
  ) {
    emit('update', $event)
  }
}

const onUpdate = ($event) => {
  result.value = $event
  emit('update', $event)
}
</script>

<style lang="scss">
.m-phone-number-input {
  flex-direction: row !important;
  .m-country-selector {
    min-width: unset !important;
  }
  .m-phone-input {
    width: 100% !important;
    flex: auto !important;
  }
}
</style>
